const { Modal } = require("bootstrap");

$(document).ready(function() {
    let response = {};
    let content_cart_info_resumo        =  document.getElementById("content_cart_info_resumo");
    let box_termos_poses                =  document.getElementById("box_termos_poses");
    let pagina;
    let valida_primeira_pagina 			= 0;
    let valida_segunda_pagina  			= 0; 
    let valida_terceira_pagina 			= 0; 
    let valida_primeira_pagina_cpf 		= 0;
    let valida_primeira_pagina_email	= 0;
    let dia_p                           = ['0','1','2','3']
    let dia_s                           = ['0','1','2','3','4','5','6','7','8','9']
    let mes_p                           = ['0','1']
    let mes_s                           = ['0','1','2']
    let mes_t                           = ['0','1','2','3','4','5','6','7','8','9']
    let senha_validada                  = false;
    let dataRetunUserEmail;
    let password_c_errors   = document.getElementById("admin_password_c_errors"); 
    let progress_bar        = document.getElementById("progress-bar");
    let liStatus1 			= document.getElementById("li-status-1");
    let liStatus2 			= document.getElementById("li-status-2");
    let liStatus3 			= document.getElementById("li-status-3");
    let liStatus4 			= document.getElementById("li-status-4");
    let liStatus5 			= document.getElementById("li-status-5");
    let leg1        		= document.getElementById("leg-1");
    let leg2        		= document.getElementById("leg-2");
    let leg3        		= document.getElementById("leg-3");
    let leg4        		= document.getElementById("leg-4");
    let leg5        		= document.getElementById("leg-5");
    let userNome    		= document.getElementById("user_nome");
    let userCpf     		= document.getElementById("user_cpf");
    let userEmail   		= document.getElementById("user_email");
    let userSenha   		= document.getElementById("user_senha");
    let userSenhaConfirm 	= document.getElementById("user_senha_confirm");
    let assNome         	= document.getElementById("ass_nome");
    let cartId              = document.getElementById("intranet_cartorio");
    let assDtNasc			= document.getElementById("ass_data_nascimento");
    let assFunc 			= document.getElementById("ass_funcao");
    let funcBox             = document.getElementById("intranet_funcao_box"); 
    let assCep 				= document.getElementById("ass_cep");
    let assLogradouro 		= document.getElementById("ass_logradouro");
    let assComplemento      = document.getElementById("ass_complemento");
    let assBairro           = document.getElementById("ass_bairro");
    let assTel1 			= document.getElementById("ass_telefone_1");
    let assTel2             = document.getElementById("ass_telefone_2")
    let assEmail			= document.getElementById("ass_email");
    let assTermoPosse       = document.getElementById("user_termo_posse");
    let dados_cart          = false  
    let carts = document.getElementById("carts");
    // assFunc.classList.add("form-control");
    cartId.classList.add("form-control");

    $("#intranet_cartorio").on('keypress', function(e){
        if(e.which == 13) {
            e.preventDefault();
        }
    });
    IMask(
        assDtNasc,
        {mask:'00/00'}
    );
    IMask(
        assTel1,
        {mask:'(00) 0 0000-0000'}
    );
    IMask(
        assTel2,
        {mask:'(00) 0 0000-0000'}
    ); 
    IMask(
        assCep,
        {mask:'00000-000'}
    ); 
    $('.step').hide();
    $('.mensagem').hide();
    $('.step').first().show();
    userCpf.onkeyup = function(){ 
        if(userCpf.value.length  >= 9){ 
            $.ajax({
                type: "get",
                beforeSend: function(xhr) {xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').last().attr('content'))},
                url: '/consulta/user',
                data: {cpf: userCpf.value},
                success: function(data) {   
                    if(data == 0){
                        if(valida_primeira_pagina_cpf == 0){   
                            if(valida_primeira_pagina_cpf == 0){ 
                                valida_primeira_pagina_cpf+=1;
                            }
                            userCpf.style.border = "1px solid #ced4da"; 
                            $("#user_cpf_exist").html(""); 
                        }
                    }else{
                        userCpf.focus();
                        userCpf.style.border= "1px solid #ea2c00"; 
                        $("#user_cpf_exist").html("Este cpf já está cadastrado."); 
                        userCpf.value = null;
                        valida_primeira_pagina_cpf = 0;
                    } 
                }
            });
        } 
    } 
    userEmail.onchange = function(){  
        $.ajax({
            type: "get",
            beforeSend: function(xhr) {xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').last().attr('content'))},
            url: '/checkemail?',
            data: 'email=' + userEmail.value,
            success: function(data) {  
                if(data.email_exists){ 
                    userEmail.focus();
                    userEmail.style.border= "1px solid #ea2c00";
                    $("#user_email_exist").html("Email já está em uso");  
                    userEmail.value = null;
                    valida_primeira_pagina_email = 0;
                }else{      
                    if(valida_primeira_pagina_email == 0){ 
                        valida_primeira_pagina_email+=1;
                    }
                    userEmail.style.border = "1px solid #ced4da";
                    $("#user_email_exist").html("");  
                };  
            }
        });  
    }  
    assDtNasc.onkeypress = function(event){ 

        if(assDtNasc.value.length == 0){  
            if(dia_p.includes(event.key) == false){ 
                return false
            }
        } 
        if(assDtNasc.value.length == 1){  
            if(assDtNasc.value.slice(-1) == 3)
                if(event.key != 1){ 
                    return false
                } 
        } 
        if(assDtNasc.value.length == 2){  
            if(mes_p.includes(event.key) == false){ 
                return false
            } 
        }
        if(assDtNasc.value.length == 3){  
            if(mes_p.includes(event.key) == false){ 
                return false
            } 
        }
        if(assDtNasc.value.length == 4){  
            if(assDtNasc.value.slice(-1) == 1){ 
                if(mes_s.includes(event.key) == false){ 
                    return false
                } 
            }else{ 
                if(mes_t.includes(event.key) == false){ 
                    return false
                } 
            }
        }
    }   

    user_senha.onkeyup  =  function(){
        let txt =$(this).val();
        let forca = 0;

        if(txt.length > 5) {
            forca += 25;
        } 

        var reg = new RegExp(/[a-z]/i);
        if(reg.test(txt)){
            forca += 25;
        }

        var reg = new RegExp(/[0-9]/i);
        if(reg.test(txt)){
            forca += 25;
        }

        var reg = new RegExp(/[^a-z0-9]/i);
        if(reg.test(txt)){
            forca += 25;
        }
        mostrarForca(forca);
    };
    function mostrarForca(forca){ 
        if(forca == 0 ){
            progress_bar.style.width = "0%"
            progress_bar.style.backgroundColor = "#ff0052"
        } 
        if(forca > 20 && forca < 45  ){
            progress_bar.style.width = "25%"
            progress_bar.style.backgroundColor = "#ff6a00"
        } 
        if(forca > 45 && forca < 70){
            progress_bar.style.width = "50%"
            progress_bar.style.backgroundColor = "#ebcb2f"
        } 
        if(forca > 70  && forca < 95){
            progress_bar.style.width = "75%"
            progress_bar.style.backgroundColor = "#4bd71d"
        } 
        if(forca > 95){
            progress_bar.style.width = "100%"
            progress_bar.style.backgroundColor = "#007bff"
        } 
    }
    user_senha_confirm.onkeyup =  function(){ 
        if(user_senha_confirm.value != user_senha.value){
            password_c_errors.innerHTML = "As senhas não coincidem"  
        }else{
            password_c_errors.innerHTML = ""   
        }
    };
    let passoexibido = function(){
        let index = parseInt($(".step:visible").index()) + 1;
        if(index == 1){
            $("#next").show();
            $("#prev").prop('disabled',true); 
            liStatus1.classList.add("active");
            liStatus2.classList.remove("active");
            liStatus3.classList.remove("active");
            liStatus4.classList.remove("active");
            leg1.classList.add("active-leg-1");
            leg2.classList.remove("active-leg-2");
            leg3.classList.remove("active-leg-3");
            leg4.classList.remove("active-leg-4");
            document.getElementById("status").style.width = "0%";
        }else if(index == 2){
            $("#next").show();
            $("#prev").prop('disabled',false); 
            liStatus1.classList.add("active");
            liStatus2.classList.add("active");
            liStatus3.classList.remove("active");
            liStatus4.classList.remove("active");
            leg1.classList.add("active-leg-1");
            leg2.classList.add("active-leg-2");
            leg3.classList.remove("active-leg-3");
            leg4.classList.remove("active-leg-4");
            document.getElementById("status").style.width = "33.33%";
        }else if(index == 3){
            $("#prev").prop('disabled',false);
            liStatus1.classList.add("active");
            liStatus2.classList.add("active");
            liStatus3.classList.add("active");
            liStatus4.classList.remove("active");
            leg1.classList.add("active-leg-1");
            leg2.classList.add("active-leg-2");
            leg3.classList.add("active-leg-3");
            leg4.classList.remove("active-leg-4");
            document.getElementById("status").style.width = "66.66%";
        }else if(index == 4){
            $("#next").hide();
            $("#prev").prop('disabled',false);
            liStatus1.classList.add("active");
            liStatus2.classList.add("active");
            liStatus3.classList.add("active");
            liStatus4.classList.add("active");
            leg1.classList.add("active-leg-1");
            leg2.classList.add("active-leg-2");
            leg3.classList.add("active-leg-3");
            leg4.classList.add("active-leg-4");
            document.getElementById("status").style.width = "99.99%";
        }
        $("#passo").html(index);  
        pagina = index;
    };
    passoexibido(); 
    function validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    };
    let validaPagina = function(){
        if(pagina == 1){
            if(userNome.value==''){
                userNome.focus();
                userNome.style.border = "1px solid #ea2c00";
                $("#user_nome_exist").html("Não pode ficar vazio."); 
            }else{
                userNome.style.border = "1px solid #ced4da";
                valida_primeira_pagina+=1; 
                $("#user_nome_exist").html(""); 
            }; 
            if(userCpf.value==''){
                userCpf.focus();
                userCpf.style.border= "1px solid #ea2c00"; 
                $("#user_cpf_exist").html("Não pode ficar vazio."); 
            }else{
                userCpf.style.border = "1px solid #ced4da";
                valida_primeira_pagina+=1; 
                $("#user_cpf_exist").html(""); 
            };

            if(userEmail.value==''){
                userEmail.focus();
                userEmail.style.border= "1px solid #ea2c00"; 
                $("#user_email_exist").html("Não pode ficar vazio."); 
            }else{ 
                valida_primeira_pagina+=1; 
            }

            if(userSenha.value==''){
                userSenha.focus();
                userSenha.style.border= "1px solid #ea2c00";  
                $("#user_senha_exist").html("Não pode ficar vazio."); 
            }else{ 
                if(userSenha.value.length < 6){
                    userSenha.focus();
                    userSenha.style.border= "1px solid #ea2c00";    
                    $("#user_senha_exist").html("No mínimo 6 digitos."); 
                    progress_bar.style.width = "0%"
                    progress_bar.style.backgroundColor = "#ff0052"
                }else{ 
                    userSenha.style.border = "1px solid #ced4da";
                    valida_primeira_pagina+=1; 
                    $("#user_senha_exist").html(""); 
                };
            };

            if(userSenhaConfirm.value==''){
                userSenhaConfirm.focus();
                userSenhaConfirm.style.border = "1px solid #ea2c00"; 
                $("#user_senha_conf_exist").html("Não pode ficar vazio."); 
                progress_bar.style.width = "0%"
                progress_bar.style.backgroundColor = "#ff0052"
            }else{
                userSenhaConfirm.style.border = "1px solid #ced4da";
                valida_primeira_pagina+=1;  
                $("#user_senha_conf_exist").html(""); 
            };

            if(valida_primeira_pagina <= 4){
                valida_primeira_pagina = 0; 
            };
        }; 
        if(pagina == 2){ 

            if(assNome.value==''){
                assNome.focus();
                assNome.style.border = "1px solid #ea2c00"; 
                $("#ass_nome_required").html("Não pode ficar vazio."); 
            }else{
                assNome.style.border = "1px solid #ced4da";
                $("#ass_nome_required").html(""); 
                valida_segunda_pagina+=1;
            };
            if(assCep.value==''){
                assCep.focus();
                assCep.style.border = "1px solid #ea2c00";
                $("#ass_cep_required").html("Não pode ficar vazio."); 
            }else{
                assCep.style.border = "1px solid #ced4da";
                $("#ass_cep_required").html(""); 
                valida_segunda_pagina+=1;
            };
            if(assLogradouro.value==''){
                assLogradouro.focus();
                assLogradouro.style.border = "1px solid #ea2c00";
                $("#ass_log_required").html("Não pode ficar vazio."); 
            }else{
                assLogradouro.style.border = "1px solid #ced4da";
                $("#ass_log_required").html(""); 
                valida_segunda_pagina+=1;
            };
            if(assTel1.value==''){
                assTel1.focus();
                assTel1.style.border = "1px solid #ea2c00";
                $("#ass_tel1_required").html("Não pode ficar vazio."); 
            }else{
                assTel1.style.border = "1px solid #ced4da";
                $("#ass_tel1_required").html(""); 
                valida_segunda_pagina+=1;
            };
            if(assEmail.value==''){
                assEmail.focus();
                assEmail.style.border = "1px solid #ea2c00";
                $("#ass_email_required").html("Não pode ficar vazio."); 
            }else{
                var re = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
                var emailFormat = re.test(assEmail.value);
                if (emailFormat) {
                    assEmail.style.border = "1px solid #ced4da";
                    $("#ass_email_required").html(""); 
                    valida_segunda_pagina+=1;
                }else{  
                    assEmail.focus();
                    assEmail.style.border = "1px solid #ea2c00"; 
                    $("#ass_email_required").html("Email Inválido."); 
                };
            }; 
            let selected = [...cartId.options]
            .filter(option => option.selected)
            .map(option => option.value); 
            let indice = selected.indexOf('')
            while(indice >= 0){
                selected.splice(indice, 1);
                indice = selected.indexOf('');
            } 
            if(selected.length > 0){
                cartId.style.border = "1px solid #ced4da";
                $("#ass_cart_id_required").html(""); 
                valida_segunda_pagina+=1;  
            }else{ 
                cartId.focus();
                cartId.style.border = "1px solid #ea2c00";
                $("#ass_cart_id_required").html("Não pode ficar vazio."); 
            } 
            assEmail.value=='' 
            if(valida_segunda_pagina <= 4){
                valida_segunda_pagina = 0; 
            };
            
        };

    }; 
    let verificaSenha = function(){
        let user_senha = userSenha.value;
        let user_senha_confirm = userSenhaConfirm.value;
        if (user_senha != user_senha_confirm){
            document.getElementById('user_senha').value='';
            document.getElementById('user_senha_confirm').value=''; 
            $("#user_senha_exist").html("As senhas não estão iguais."); 
            progress_bar.style.width = "0%"
            progress_bar.style.backgroundColor = "#ff0052"
            senha_validada = false;
        }else if(user_senha.length < 6){   
            $("#user_senha_exist").html("Senha não pode ficar vazia."); 
            progress_bar.style.width = "0%"
            progress_bar.style.backgroundColor = "#ff0052"
            senha_validada = false;
        }else{ 
            if(user_senha.length < 6 || user_senha == null){ 
                senha_validada = false;
            }else{ 
                senha_validada = true;
            }
        }
    };
    let listarTermosInput = function(cartorios_ids){
        let inputs = []; 
        var count   = 0;
        for( count in response[0]){  
            inputs[count] = `<div class="page-header">
                            <h1 style="border-bottom: 1px solid #f8f9fa;margin-top: 3%;font-size: 18px;">${response[0][count][1]}</h1>      
                        </div>
                        <p>Anexe os documentos relacionados a este respectivo cartório.</p>
                        <label>Termo de posse</label><br>
                        <input style="width: 97%;margin-top: 20px;" type="file" name="termo_posse_${response[0][count][9]}" required="true" id="user_termo_posse" accept:".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" class="form-control"><br>
                        <label>Ficha de filiação</label><br>
                        <input style="width: 97%;margin-top: 20px;" type="file" name="ficha_assinada_${response[0][count][9]}" required="true" id="fixa_assinada" accept:".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" class="form-control"><br>`;
        }
        
        box_termos_poses.innerHTML = inputs.join("<br>");
    }

    $("#next").click(function(){
       
        if(pagina == 1){
            validaPagina();
            let aux_contagem = 0
            verificaSenha();     
            aux_contagem = valida_primeira_pagina + valida_primeira_pagina_cpf + valida_primeira_pagina_email 
            if(senha_validada == true ){  
                if( aux_contagem == 7){
                    $("#exampleModal2").modal('show')
                    valida_primeira_pagina = 0; 
                }
            };
        };
        if(pagina == 2){
            validaPagina();
            if(valida_segunda_pagina == 5 ){ 
                $(".step:visible").hide().next().fadeIn();
                 passoexibido();  
                
                valida_segunda_pagina = 0;
            }  
        };
        if(pagina == 3){
            $("#next").hide();
            passoexibido();   
            let selected = [...cartId.options]
            .filter(option => option.selected)
            .map(option => option.value); 
            let indice = selected.indexOf('')
            while(indice >= 0){
                selected.splice(indice, 1);
                indice = selected.indexOf('');
            }
            

            $.ajax({
                type: "get",
                beforeSend: function(xhr) {xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').last().attr('content'))},
                url: '/verifica/dados/cart',
                data: 'ids=' + selected,
                success: function(data) {
                    response = data;
                    listarTermosInput(selected);
                    for (var i=0; i<data[0].length; i++){
                       
                        carts.innerHTML += 
                        `<div class="form-control mb-4">
                                <h4 class="mt-3" style="border-bottom: 1px solid #e6e6e6;height: 40px;margin-bottom: 11px;"><strong>Dados do Cartório nº ${i+1}</strong></h4>
                                <input type="hidden" id="idcart${i}" value="${data[0][i][9] || ""}">
                                <input type="hidden" id="idcidade${i}" value="${data[0][i][14] || ""}">
                                <input type="hidden" id="cartCount${i}" value="${i}">
                            <div class="form-group">
                                <label>Cartório</label>
                                <input type="text" name="cartorio[cartorio${i}]" class="form-control" id="cartorio${i}" value="${data[0][i][1] || ""}" readonly>
                            </div>
                            <div class="form-group">
                                <label>Cnpj</label>*<span id="ass_cnpj3_required${i}" style="font-size: 12px;padding: 5px;float: inline-end;color: #b30303;"></span>
                                <input type="text" name="cnpj[cpnj${i}]" class="form-control" id="cnpj${i}" value="${data[0][i][0] ||""}" >
                            </div>
                            <div class="form-group">
                                <label>Codigo Tj</label>
                                <input type="text" name="cod_tj[cod_tj${i}]" class="form-control" id="cod_tj${i}" value="${data[0][i][7] || ""}" readonly>
                            </div>
                            <div class="form-group">
                                <label>Código CNS</label>
                                <input type="text" name="cod_cns[cod_cnd${i}]" class="form-control" id="cod_cns${i}" value="${data[0][i][6] || ""}" readonly >
                            </div>
                            <div class="form-group">
                                <label>Nome Fantasia</label>*<span id="ass_fant3_required${i}" style="font-size: 12px;padding: 5px;float: inline-end;color: #b30303;"></span>
                                <input type="text" name="nomefantasia[nomefantasia${i}]" class="form-control" id="nomefantasia${i}" value="${data[0][i][2] || ""}">
                            </div>
                            <div class="form-group">
                                <label>Cep</label>*<span id="ass_cep3_required${i}" style="font-size: 12px;padding: 5px;float: inline-end;color: #b30303;"></span>
                                <input type="text" name="cep[cep${i}]" class="form-control cepMask" id="cep${i}" value="${data[0][i][10]||""}" >
                            </div>
                            <div class="form-group">
                                <label>Endereço</label>*<span id="ass_endereco3_required${i}" style="font-size: 12px;padding: 5px;float: inline-end;color: #b30303;"></span>
                                <input type="text" name="endereco[endereco${i}]" class="form-control" id="endereco${i}" value="${data[0][i][5] || ""}">
                            </div>
                            <div class="form-group">
                                <label>Complemento</label>
                                <input type="text" name="complemento[complemento${i}]" class="form-control" id="complemento${i}" value="${data[0][i][13] || ""}" >
                            </div>

                            <div class="form-group">
                                <label>Bairro</label>
                                <input type="text" name="bairro[bairro${i}]" class="form-control" id="bairro${i}" value="${data[0][i][12] || ""}">
                            </div>
                            <div class="form-group">
                                <label>Telefone</label>*<span id="ass_telefone3_required${i}" style="font-size: 12px;padding: 5px;float: inline-end;color: #b30303;"></span>
                                <input type="text" name="telefone" class="form-control telMask" id="telefone${i}" value="${data[0][i][4] || ""}" placeholder="(99)99999-9999">	
                            </div>
                            <div class="form-group">
                                <label>Telefone Celular</label>*<span id="ass_telefoneCel3_required${i}" style="font-size: 12px;padding: 5px;float: inline-end;color: #b30303;"></span>
                                <input type="text" name="telefoneCel[telefoneCel${i}]" class="form-control telCelMask" id="telefoneCel${i}" value="${data[0][i][3]|| ""}" placeholder="(99)99999-9999">	
                            </div>
                            <div class="form-group">
                                <label>Email</label>*<span id="ass_email3_required${i}" style="font-size: 12px;padding: 5px;float: inline-end;color: #b30303;"></span>
                                <input type="email" name="email" class="form-control" id="email${i}" value="${data[0][i][8] ||""}" >
                            </div>
                            <div class="form-group">
                                <label>Instagram</label>
                                <input type="text" name="instagram" class="form-control" id="instagram${i}" value="${data[0][i][11] || ""}" >
                            </div>
                            <div class="form-group">                             
                                <label>Função do Associado</label>
                                <div class="form-check container mt-2">
                                    <div class="form-check form-check-inline col-md-4">
                                        <input class="form-check-input" type="radio" name="funcao${i}"  value="Titular">
                                        <label class="form-check-label" for="funcao">
                                            Titular
                                        </label>
                                    </div>
                                    <div class="form-check form-check-inline col-md-3">
                                        <input class="form-check-input" type="radio" name="funcao${i}" value="Interino" >
                                        <label class="form-check-label" for="funcao">
                                        Interino
                                        </label>
                                    </div>
                                    <div class="form-check form-check-inline col-md-3">
                                        <input class="form-check-input" type="radio" name="funcao${i}" value="Substituto" >
                                        <label class="form-check-label" for="funcao">
                                            Substituto
                                        </label>
                                    </div>
                                </div>
                                						
						    </div>
                            
                            
                            <hr>
                            <h4 style="border-bottom: 1px solid #e6e6e6;height: 40px;margin-bottom: 11px;">Dados do Tabelião | Interino</h4>
                            <input type="hidden" name="idtab[idtab${i}]" id="idTab${i}" value="${  data[1][i].length == 0 ? "" : data[1][i][0].id}">
                            <div class="form-group">
                                <label>CPF</label>*<span id="cpfTab_required${i}" style="font-size: 12px;padding: 5px;float: inline-end;color: #b30303;"></span>
                                <input type="text" name="cpfTab[cpfTab${i}]" class="form-control cpfMask" id="cpfTab${i}" value="${ data[1][i].length == 0 ? "" : data[1][i][0].cpf || ""}" maxlength="14" placeholder="999.999.999-99">
                            </div>
    
                            <div class="form-group">
                                <label>Nome</label>*<span id="nomeTab_required${i}" style="font-size: 12px;padding: 5px;float: inline-end;color: #b30303;"></span>
                                <input type="text" name="nomeTab[nomeTab${i}]" class="form-control" id="nomeTab${i}" value="${  data[1][i].length == 0 ? "" : data[1][i][0].nome || ""}">
                            </div>
    
                            <div class="form-group">
                                <label>WhatsApp</label>*<span id="telTab_required${i}" style="font-size: 12px;padding: 5px;float: inline-end;color: #b30303;"></span>
                                <input type="text" name="telefoneTab[telefoneTab${i}]" class="form-control telMask" id="telefoneTab${i}" value="${  data[1][i].length == 0 ? "" : data[1][i][0].telefone || ""}" placeholder="(99)99999-9999">
                            </div>
    
                            <div class="form-group">
                                <label>Email*</label><span id="emailTab_required${i}" style="font-size: 12px;padding: 5px;float: inline-end;color: #b30303;"></span>
                                <input type="email" name="emailTab[emailTab${i}]" class="form-control" id="emailTab${i}" value="${ data[1][i].length == 0 ? "" : data[1][i][0].email || ""}" ><br> 
                            </div>

                            <hr>
                            <h4>Dados do Substituto</h4>
                            <input type="hidden" id="idSubs${i}" value="${ data[3][i].length == 0 ? "" : data[3][i][0].id || ""}">
                            <div class="form-group">
                                <label>Cpf</label>
                                <input type="text" name="cpfSubs[cpfSubs${i}]" class="form-control cpfMask" id="cpfSubs${i}" value="${ data[3][i].length == 0 ? "" : data[3][i][0].cpf || ""}" maxlength= "14" placeholder="999.999.999-99">
                            </div>
                            <div class="form-group">
                                <label>Nome</label>
                                <input type="text" name="nomeSubs[nomeSubs${i}]" class="form-control" id="nomeSubs${i}" value="${ data[3][i].length == 0 ? "" : data[3][i][0].nome || ""}" > 
                            </div>
                            <div class="form-group">
                                <label>Telefone</label>
                                <input type="text" name="telefoneSubs[telefoneSubs${i}]" class="form-control telMask" id="telefoneSubs${i}" value="${data[3][i].length == 0 ? "" : data[3][i][0].telefone || ""}" placeholder="(99) 99999-9999">
                            </div>
                            <div class="form-group">
                                <label>Email</label>
                                <input type="email" name="emailSubs[emailSubs${i}]" class="form-control" id="emailSubs${i}" value="${data[3][i].length == 0 ? "" : data[3][i][0].email || ""}" >
                            </div>

                            <div class="mt-3 d-flex flex-row-reverse justify-content-between" style="text-align: left">
                                <div class="form-group">
                                    <a class="btn btn-primary salvarCartorio" cart="${i}">Salvar Cartório nº ${i+1}</a>
                                </div>
                                <div id="gpdf${i}" style="display: none"><a class="gerarPdf" cart="${i}" ><i class="fas fa-file-pdf fa-2x" style="margin-left:20px" ></i></a><br><span style="font-size:12px; font-weight:bold">Gerar ficha</span></div>
                            </div>
                            
                        </div>`;
                            //associado                             
                            let assNome =$("#user_nome").val();
                            let assCpf = $("#user_cpf").val();
                            let dtaNascimento = $("#ass_data_nascimento").val();
                            let assCep = $("#ass_cep").val();
                            let assLogradouro = $("#ass_logradouro").val();
                            let assComplemento = $("#ass_complemento").val();
                            let assBairro = $("#ass_bairro").val();
                            let assTelefone1 = $("#ass_telefone_1").val();
                            let assTelefone2 = $("#ass_telefone_2").val();
                            let assEmail = $("#ass_email").val();
                            let opcoes = [];
                            opcoes[i] = $('input[name=funcao'+i+']:checked').val(); 
                            $("#funcoes").val(opcoes[i]);
                            $(".salvarCartorio").on('click', function(event){
                                event.preventDefault();
                                let num =  this.getAttributeNames().reduce((acc, name) => {
                                    return {...acc, [name]: this.getAttribute(name)};
                                }, {});
                                let validaCampos = 0;

                                /* Inicio Cartorio */
                                if ($("#cnpj"+num.cart).val() == 0 || $("#cnpj"+num.cart).val() == "") {
                                    $("#ass_cnpj3_required"+num.cart).html("Não pode ficar vazio");
                                } else {
                                    validaCampos = validaCampos + 1;
                                }

                                if ($("#nomefantasia"+num.cart).val() == 0 || $("#nomefantasia"+num.cart).val() == "") {
                                    $("#ass_fant3_required"+num.cart).html("Não pode ficar vazio");     
                                } else {
                                    validaCampos = validaCampos + 1;
                                }

                                if ($("#cep"+num.cart).val() == 0 || $("#cep"+num.cart).val() == "") {
                                    $("#ass_cep3_required"+num.cart).html("Não pode ficar vazio");
                                } else {
                                    validaCampos = validaCampos + 1;
                                }

                                if ($("#endereco"+num.cart).val() == 0 || $("#endereco"+num.cart).val() == "") {
                                    $("#ass_endereco3_required"+num.cart).html("Não pode ficar vazio");
                                } else {
                                    validaCampos = validaCampos + 1;
                                }

                                if ($("#telefone"+num.cart).val() == 0 || $("#telefone"+num.cart).val() == "") {
                                    $("#ass_telefone3_required"+num.cart).html("Não pode ficar vazio");
                                } else {
                                    validaCampos = validaCampos + 1;
                                }

                                if ($("#telefoneCel"+num.cart).val() == 0 || $("#telefoneCel"+num.cart).val() == "") {
                                    $("#ass_telefoneCel3_required"+num.cart).html("Não pode ficar vazio");                             
                                } else {
                                    validaCampos = validaCampos + 1;
                                }
                                
                                if ($("#email"+num.cart).val() == 0 || $("#email"+num.cart).val() == "") {
                                    $("#ass_email3_required"+num.cart).html("Não pode ficar vazio");    
                                } else {
                                    validaCampos = validaCampos + 1;
                                }
                                /* FIm Cartório */

                                /* Tabelião */
                                if ($("#cpfTab"+num.cart).val() == 0 || $("#cpfTab"+num.cart).val() == "") {
                                    $("#cpfTab_required"+num.cart).html("Não pode ficar vazio");                                  
                                } else {
                                    validaCampos = validaCampos +1;
                                }

                                if ($("#nomeTab"+num.cart).val() == 0 || $("#nomeTab"+num.cart).val() == "") {
                                    $("#nomeTab_required"+num.cart).html("Não pode ficar vazio");
                                } else {
                                    validaCampos = validaCampos +1;
                                }

                                if ($("#telefoneTab"+num.cart).val() == 0 || $("#telefoneTab"+num.cart).val() == "") {
                                    $("#telTab_required"+num.cart).html("Não pode ficar vazio");
                                } else {
                                    validaCampos = validaCampos + 1;
                                }

                                if($("#whatsappTab"+num.cart).val() == 0 || $("#whatsappTab"+num.cart).val() == "" ) {
                                    $("#wppTab_required"+num.cart).html("Não pode ficar vazio");
                                } else {
                                    validaCampos = validaCampos + 1;
                                }

                                
                                if ($("#emailTab"+num.cart).val() == 0 || $("#emailTab"+num.cart).val() == "") {
                                    $("#emailTab_required"+num.cart).html("Não pode ficar vazio");
                                } else {
                                    validaCampos = validaCampos +1;
                                }

                                if (validaCampos == 12) {
                                    // Salvar dados do cartorio
                                   
                                    var myModal = new bootstrap.Modal(document.getElementById('aviso2'), {
                                        keyboard: false
                                      })
                                    myModal.show();
                                    $("#msgAviso").html("<strong>Dados do cartório salvo com sucesso. Por favor, clique no botão gerar ficha, para continuar</strong>");
                                    $.ajax({
                                        type: "POST",
                                        beforeSend: function(xhr) {xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').last().attr('content'))},
                                        url: '/salvarDadosCart',
                                        dataType: 'JSON',
                                        async: false,
                                        data: 
                                        {
                                            idCart: $("#idcart"+num.cart).val(),
                                            cartCount: $("#cartCount"+num.cart).val(),
                                            assocCount: data[2],
                                            cidadeId: $("#idcidade"+num.cart).val(),
                                            cartorio: $("#cartorio"+num.cart).val(),
                                            nomefantasia: $("#nomefantasia"+num.cart).val(),
                                            cnpj: $("#cnpj"+num.cart).val(),
                                            codtj: $("#cod_tj"+num.cart).val(),
                                            codcns: $("#cod_cns"+num.cart).val(),
                                            enderecoCart: $("#endereco"+num.cart).val(),
                                            complementoCart: $("#complemento"+num.cart).val(),
                                            bairroCart: $("#bairro"+num.cart).val(),
                                            cepCart: $("#cep"+num.cart).val(),
                                            telefone1Cart: $("#telefone"+num.cart).val(),
                                            telefone2Cart: $("#telefoneCel"+num.cart).val(),
                                            emailCart: $("#email"+num.cart).val(),
                                            instagram: $("#instagram"+num.cart).val(),
                                            funcao: $('input[name=funcao'+num.cart+']:checked').val(),
                                            idTab: $('#idTab'+num.cart).val(),
                                            cpfTab: $('#cpfTab'+num.cart).val(),
                                            nomeTab: $('#nomeTab'+num.cart).val(),
                                            telefoneTab: $('#telefoneTab'+num.cart).val(),
                                            whatsappTab: $('#whatsappTab'+num.cart).val(),
                                            emailTab: $('#emailTab'+num.cart).val(),
                                            idSubs: $("#idSubs"+num.cart).val(),
                                            cpfSubs: $("#cpfSubs"+ num.cart).val(),
                                            nomeSubs: $("#nomeSubs" + num.cart).val(),
                                            telefoneSubs: $("#telefoneSubs"+num.cart).val(),
                                            emailSubs: $("#emailSubs"+num.cart).val()

                                        },
                                        success: function(data) {
                                            $("#gpdf"+num.cart).css('display', 'block');
                                    
                                        }
                                    });
                                    $(".gerarPdf").on('click',function(event){
                                        event.preventDefault();
                                        let num =  this.getAttributeNames().reduce((acc, name) => {
                                            return {...acc, [name]: this.getAttribute(name)};
                                        }, {});
                                        var myModal = new bootstrap.Modal(document.getElementById('aviso2'), {
                                            keyboard: false
                                          })
                                        myModal.show();
                                        $("#msgAviso").html("<strong>Gerando ficha. Por favor, aguarde...</strong><br><div class='d-flex justify-content-center'><div class='spinner-border text-primary mt-3' role='status'  style='height: 80px; width: 80px;'><span class='visually-hidden'>Loading...</span></div></div>");
                                        
                                        $.ajax({
                                            type: "POST",
                                            beforeSend: function(xhr) {xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').last().attr('content'))},
                                            url: '/gerarFicha',
                                            dataType: 'JSON',
                                            data: 
                                            {
                                                idCart: $("#idcart"+num.cart).val(),
                                                cartCount: $("#cartCount"+num.cart).val(),
                                                assocCount: data[2],
                                                cidadeId: $("#idcidade"+num.cart).val(),
                                                cartorio: $("#cartorio"+num.cart).val(),
                                                cnpj: $("#cnpj"+num.cart).val(),
                                                enderecoCart: $("#endereco"+num.cart).val(),
                                                complementoCart: $("#complemento"+num.cart).val(),
                                                bairroCart: $("#bairro"+num.cart).val(),
                                                cepCart: $("#cep"+num.cart).val(),
                                                telefone1Cart: $("#telefone"+num.cart).val(),
                                                telefone2Cart: $("#telefoneCel"+num.cart).val(),
                                                emailCart: $("#email"+num.cart).val(),
                                                instagram: $("#instagram"+num.cart).val(),
                                                funcao: $('input[name=funcao'+num.cart+']:checked').val(),
                                                assNome: assNome,
                                                assCpf: assCpf,
                                                dtaNascimento: dtaNascimento,
                                                assCep: assCep,
                                                assLogradouro: assLogradouro,
                                                assComplemento: assComplemento,
                                                assBairro: assBairro,
                                                assTelefone1: assTelefone1,
                                                assTelefone2: assTelefone2,
                                                assEmail: assEmail
                                            },
                                            success: function(data) {
                                                // var myModal = new bootstrap.Modal(document.getElementById('aviso2'), {
                                                //     keyboard: false
                                                //   })
                                                // myModal.show();
                                                $("#msgAviso").html("<strong>Ficha gerada com sucesso. Por favor, realize a assinatura da ficha para prosseguir ao próximo passo.</strong>");
                                                $("#fechar").on('click', function(){
                                                    myModal.hide();
                                                });
                                                let id = $("#idcart"+num.cart).val();
                                                window.open("/termo_filiacao_"+id+".pdf", "_blank").focus();
                                                $("#next").show();
                                        
                                            }
                                        });
                                        
                                    });
                                } else {
                                    $("#gpdf"+num.cart).css('display', 'none');
                                    var myModal = new bootstrap.Modal(document.getElementById('aviso2'), {
                                        keyboard: false
                                      })
                                    myModal.show();
                                    $("#msgAviso").html("<strong>Existem campos obrigatórios a preencher. Por favor, verifique-os e tente novamente.</strong>");
                                    validaCampos = 0;
                                }
                            });                   
                    }
                    $("#next").on('click', function(){
                        $("#next").css("display: none");
                        $(".step:visible").hide().next().fadeIn();
                    });
                    $(".cpfMask").mask("999.999.999-99");
                    $(".telMask").mask("(99) 9999-9999");
                    $(".telCelMask").mask("(99) 99999-9999");
                    $(".cepMask").mask("99999-999")
                
                }
            });
            // 
        }
       
    });
    $("#termos_de_uso").click(function(){   
        if(pagina == 1){    
            $("#exampleModal2").modal('hide') 
            $(".step:visible").hide().next().fadeIn();  
            passoexibido(); 
        };
    });
   
    $("#prev").click(function(){

        var myModal = new bootstrap.Modal(document.getElementById('aviso'), {
            keyboard: false
          })
        myModal.show();
    });
    $("#recomecar").on('click',function(){
        document.location.reload(true); 
    });
});

$(document).on('keyup keypress', 'form input[type="text"]', function(e) {
    if(e.keyCode == 13) {
    e.preventDefault();
    return false;
    }
});  
